import React, { memo } from "react";
import { ListGroup } from "reactstrap";
import { getAccess } from "../../services/UserService";
import CustomerChatRow from "./CustomerChatRow";

/**
 * CustomerChatList – pure, reusable list
 * Props are intentionally explicit so the list has no hidden coupling.
 */
export const CustomerChatList = memo(function CustomerChatList({
    visibleChats,
    selected,
    onSelect,
    buildMoreActions,
    assigneeOpenChatId,
    setAssigneeOpenChatId,
    onAssignToMe,
    onAssigneeCommitted,
    onStatusChange,
    ChannelIcon,

    canArchive = getAccess().features().FeatureCanArchive(),
}) {
    return (
        <ListGroup flush>
            {visibleChats.map(chat => {
                const hasUnread =
                    Number(chat.UnreadInboundCount || 0) > 0 ||
                    Number(chat.UnreadMentionCount || 0) > 0 ||
                    Boolean(chat.IsManuallyUnread);
                const active = selected?.ChatID === chat.ChatID;
                return (
                    <CustomerChatRow
                        key={chat.ChatID}
                        chat={chat}
                        active={active}
                        needsAttention={hasUnread}
                        onSelect={onSelect}
                        buildMoreActions={buildMoreActions}
                        assigneeOpenChatId={assigneeOpenChatId}
                        setAssigneeOpenChatId={setAssigneeOpenChatId}
                        onAssignToMe={onAssignToMe}
                        onAssigneeCommitted={onAssigneeCommitted}
                        onStatusChange={onStatusChange}
                        ChannelIcon={ChannelIcon}
                        canArchive={canArchive}
                        canEdit={!!chat.CanEdit}
                        selectedTextClass={active ? "text-light" : "text-muted"}
                    />
                );
            })}
        </ListGroup>
    );
});
